export { default } from './Main';



// WEBPACK FOOTER //
// ./src/scenes/Main/index.js